module.exports = __webpack_public_path__ + "img/cutaway.4a16d83c.png";